import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import TenantDashboard from './pages/TenantDashboard';
import DriverLogin from './pages/DriverLogin';
import DriverDashboard from './pages/DriverDashboard';
import { jwtDecode } from 'jwt-decode';
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentDriver, setCurrentDriver] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for user token
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 > Date.now()) {
          const user = JSON.parse(localStorage.getItem('user') || '{}');
          setCurrentUser(user);
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }

    // Check for driver token
    const driverToken = localStorage.getItem('driver_token');
    if (driverToken) {
      try {
        const decoded = jwtDecode(driverToken);
        if (decoded.exp * 1000 > Date.now()) {
          const driver = JSON.parse(localStorage.getItem('driver') || '{}');
          setCurrentDriver(driver);
        } else {
          localStorage.removeItem('driver_token');
          localStorage.removeItem('driver');
        }
      } catch (e) {
        localStorage.removeItem('driver_token');
        localStorage.removeItem('driver');
      }
    }

    setIsLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
  };

  const handleDriverLogout = () => {
    localStorage.removeItem('driver_token');
    localStorage.removeItem('driver');
    setCurrentDriver(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/login" 
          element={
            currentUser ? 
            <Navigate to={currentUser.role_type === 'super_admin' ? '/super-admin' : '/dashboard'} /> : 
            <LoginPage setCurrentUser={setCurrentUser} />
          } 
        />
        <Route 
          path="/driver-login" 
          element={
            currentDriver ? 
            <Navigate to="/driver-dashboard" /> : 
            <DriverLogin setCurrentDriver={setCurrentDriver} />
          } 
        />
        <Route 
          path="/driver-dashboard" 
          element={
            currentDriver ? 
            <DriverDashboard currentDriver={currentDriver} onLogout={handleDriverLogout} /> : 
            <Navigate to="/driver-login" />
          } 
        />
        <Route 
          path="/super-admin/*" 
          element={
            currentUser && currentUser.role_type === 'super_admin' ? 
            <SuperAdminDashboard currentUser={currentUser} onLogout={handleLogout} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route 
          path="/dashboard/*" 
          element={
            currentUser && (currentUser.role_type === 'tenant_admin' || currentUser.role_type === 'staff') ? 
            <TenantDashboard currentUser={currentUser} onLogout={handleLogout} /> : 
            <Navigate to="/login" />
          } 
        />
        <Route 
          path="/" 
          element={
            <Navigate to={
              currentDriver ? '/driver-dashboard' :
              currentUser ? (currentUser.role_type === 'super_admin' ? '/super-admin' : '/dashboard') : 
              '/login'
            } />
          } 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
